import { BasicContentWrapperComponent } from './basic-content-wrapper/basic-content-wrapper.component';
import { BasicContentComponent } from './basic-content.component';
import { BasicContentPartialHeadingComponent } from './partials/basic-content-partial-heading/basic-content-partial-heading.component';
import { BasicContentPartialTopBetweenComponent } from './partials/basic-content-partial-top-between/basic-content-partial-top-between.component';
import { BasicContentVariantJumbotronComponent } from './variants/basic-content-variant-jumbotron/basic-content-variant-jumbotron.component';
import { BasicContentVariantMinimalComponent } from './variants/basic-content-variant-minimal/basic-content-variant-minimal.component';
import { BasicContentVariantNgContentBetweenComponent } from './variants/basic-content-variant-ng-content-between/basic-content-variant-ng-content-between.component';
import { BasicContentVariantPlaceholderComponent } from './variants/basic-content-variant-placeholder/basic-content-variant-placeholder.component';
import { BasicContentVariantVerticalIconComponent } from './variants/basic-content-variant-vertical-icon/basic-content-variant-vertical-icon.component';
import { BasicContentVariantVerticalImageComponent } from './variants/basic-content-variant-vertical-image/basic-content-variant-vertical-image.component';

const basicContentVariants = [
  BasicContentVariantMinimalComponent,
  BasicContentVariantNgContentBetweenComponent,
  BasicContentVariantVerticalIconComponent,
  BasicContentVariantVerticalImageComponent,
  BasicContentVariantPlaceholderComponent,
  BasicContentVariantJumbotronComponent,
];

export const basicContentComponents = [
  ...basicContentVariants,
  BasicContentComponent,
  BasicContentWrapperComponent,
  BasicContentPartialHeadingComponent,
  BasicContentPartialTopBetweenComponent,
];
